import { AddButton, AddButtonProps } from "@/shared/form/button";
import { FormInModal } from "@/shared/form/form-in-modal";
import { CreateCompanyDocumentConfirmation } from "./create-company-document-confirmation";
import { useTranslations } from "use-intl";

export function CreateCompanyDocumentConfirmationInModal({
  documentId,
  triggerProps,
}: {
  documentId: string;
  triggerProps?: AddButtonProps;
}) {
  const t = useTranslations("Documents");

  return (
    <FormInModal
      title={t("Create confirmation")}
      trigger={(open) => (
        <AddButton onClick={open} {...triggerProps}>
          {t("Create confirmation")}
        </AddButton>
      )}
      form={(close) => (
        <CreateCompanyDocumentConfirmation
          documentId={documentId}
          afterSubmit={close}
        />
      )}
    />
  );
}
